import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=cbaffc48&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbaffc48')) {
      api.createRecord('cbaffc48', component.options)
    } else {
      api.reload('cbaffc48', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=cbaffc48&lang=pug&", function () {
      api.rerender('cbaffc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/components/Header.vue"
export default component.exports